import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SearchCurrencyBooksQueryVariables = Types.Exact<{
  where?: Types.Maybe<Types.Currency_Books_Bool_Exp>;
  limit?: Types.Maybe<Types.Scalars["Int"]>;
  order_by?: Types.Maybe<Array<Types.Currency_Books_Order_By>>;
}>;

export type SearchCurrencyBooksQuery = { __typename?: "query_root" } & {
  currency_books: Array<
    { __typename?: "currency_books" } & Pick<
      Types.Currency_Books,
      "id" | "name" | "currency_id"
    >
  >;
};

export const SearchCurrencyBooksDocument = gql`
  query SearchCurrencyBooks(
    $where: currency_books_bool_exp
    $limit: Int
    $order_by: [currency_books_order_by!]
  ) {
    currency_books(where: $where, limit: $limit, order_by: $order_by) {
      id
      name
      currency_id
    }
  }
`;

export function useSearchCurrencyBooksQuery(
  options: Omit<
    Urql.UseQueryArgs<SearchCurrencyBooksQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<SearchCurrencyBooksQuery>({
    query: SearchCurrencyBooksDocument,
    ...options,
  });
}
